import { cookiePrefix, participantSuffix, getParticipantCookieName } from './cookieNames';

export const getAllTestParticipations = (
  cookies: Record<string, string>,
): Array<{
  testId: string;
  participantId: string;
  variant?: Record<string, string>;
}> => {
  const testIds = Object.keys(cookies).reduce((accumulator, key) => {
    if (!key.startsWith(cookiePrefix)) return accumulator;

    const testId = key.replace(cookiePrefix, '').replace(participantSuffix, '');

    if (!accumulator.includes(testId)) {
      accumulator.push(testId);
    }

    return accumulator;
  }, [] as string[]);

  return testIds.map((testId) => {
    const fullCookieKey = `${cookiePrefix}${testId}`;

    if (cookies[fullCookieKey]) {
      const { participant, variant } = JSON.parse(cookies[fullCookieKey]) as {
        participant: string;
        variant: Record<string, string>;
      };

      return { testId, participantId: participant, variant };
    }

    const participantCookieKey = getParticipantCookieName(testId);

    return {
      testId,
      participantId: cookies[participantCookieKey],
    };
  });
};
